import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteVirtualSensor } from "services/ConfigServices";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { virtualsensortext } from "variables/MBM/virtualsensor.js";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import VirtualSensorDialog from "./VirtualSensorDialog.js";
import useVirtualSensorsTable from "./useVirtualSensorsTable.js";


const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles2 = makeStyles((theme) => ({
  StatusOKIcon: {
    color: "#91c241",
    fontSize: "31px"
  },
  StatusWarningIcon: {
    color: "#FF763",
    fontSize: "31px"
  },
  StatusUnknownIcon: {
    color: "#605f70",
    fontSize: "31px"
  },
  StatusDangerIcon: {
    color: "#f44336",
    fontSize: "31px"
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTVirtualSensors = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin"); //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentSensor, setCurrentSensor] = useState(null);
  const { gridState, refetch, setAvobboxs } = useVirtualSensorsTable();

  let dataSensor = gridState.data;

  const classes = useStyles();
  const classes2 = useStyles2();
  const columns = [
    {
      name: virtualsensortext.id,
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) => row.id,
    },
    {
      name: virtualsensortext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    // {
    //   name: virtualsensortext.frequency,
    //   selector: (row) => row.frequency,
    //   sortable: true,
    //   maxWidth: "10rem",
    //   cell: (row) => row.frequency,
    // },
    {
      name: virtualsensortext.group,
      selector: (row) => groupInfoListById["" + row.groupid] || "",
      sortable: true,
     // maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
             {mbm_admin && (
              <>
                <Tooltip title={virtualsensortext.edit}>
                  <Button
                    onClick={editVirtualSensor(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title={virtualsensortext.delete}>
                  <CustomDeleteButton
                    deleteTitle={virtualsensortext.delete}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le capteur virtuel ' ${row.name}?`}
                    handleSupprimer={deleteVirtualSensorFunction(row)}
                  />
                </Tooltip></>
            )} 
          </div>
        </>
      ),
    },
  ];


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editVirtualSensor = (row) => async () => {
    let obj = dataSensor.find((o) => o.id === row.id);
    if (obj) {
      setCurrentSensor(obj);
      handleClickOpen();
    }
  }

  const deleteVirtualSensorFunction = (row) => async () => {
    let obj = dataSensor.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let type = obj.type;
    let url = deleteVirtualSensor(idSelected, type);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le capteur virtuel a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setAvobboxs(selection.selectedRows);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>{virtualsensortext.nosession}</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {virtualsensortext.edit}
        </CustomDialogTitle>
        <DialogContent dividers>
          <VirtualSensorDialog
            currentSensor={currentSensor}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTVirtualSensors;
